<app-header />

<router-outlet />

<app-footer />

<app-whatsapp-fab [whatsappUrl]="whatsappUrl" />
<app-back-to-top />

<app-auth-modal />
<app-cart-drawer />
<app-prepurchase-modal />
<app-stock-alert-modal />
<app-perron-points-modal />
<app-early-access-blocked-dialog />
<app-compare-bar />
<app-search-overlay />
<!-- Pop-up del newsletter (B9 web, W6): perezoso, fuera del bundle inicial; solo actúa en el navegador. -->
@defer (on idle) {
  <app-newsletter-popup />
}
<!-- Diálogo de eventos (D20, D27): montaje único, fuera del bundle inicial y del SSR.
     Su chunk se descarga en reposo para que el primer clic no espere; se pinta la
     primera vez que algo lo abre y desde entonces se queda montado. -->
@defer (when eventDialog.isOpen(); prefetch on idle) {
  <app-event-dialog />
}
<app-toast-stack />
<app-processing-overlay />
